import React from 'react';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-col">
            <h3>Contacto</h3>
            <p>Calle Martín Muñoz de las Posadas, 1C Local</p>
            <p>Vallecas, Madrid</p>
            <p>Teléfono: <a href="tel:+34633030758">633 030 758</a></p>
          </div>
          <div className="footer-col">
            <h3>Horarios</h3>
            <p>Lunes a Viernes: 09:00–20:00</p>
            <p>Martes y Jueves: 11:00–21:30</p>
            <p>Sábado: 09:00–15:00</p>
            <p>Domingo: Cerrado</p>
          </div>
          <div className="footer-col">
            <h3>Síguenos</h3>
            <p>Mantente al día con nuestras últimas novedades y promociones</p>
            <a href="https://www.instagram.com/ari_lashes_beauty" className="instagram-link" target="_blank" rel="noopener noreferrer">
              <i>📷</i>
              <span>@ari_lashes_beauty</span>
            </a>
          </div>
        </div>
        <div className="copyright">
          <p>&copy; 2025 Ari Lashes & Brow. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;